import { z } from 'zod';
// The grammar of a slug: runs of lowercase alphanumerics joined by a single
// hyphen. `SLUG` recognises it, `RUNS` produces it. A skill's frontmatter `name`
// doubles as its slug and as a sandbox path segment, so it must be
// filesystem-safe.
const SLUG = /^[a-z\d]+(?:-[a-z\d]+)*$/;
const RUNS = /[a-z\d]+/g;
// NFD splits a letter from its accents and `\p{Diacritic}` drops them. What is
// left are the letters that do not decompose, the only thing lodash `deburr`
// knew that NFD does not. Latin Extended-B (Romanian, Vietnamese, pinyin) comes
// free with NFD, where the lodash table stops at Latin Extended-A.
const LIGATURES = {
    æ: 'ae', œ: 'oe', ß: 'ss', ø: 'o', đ: 'd', ð: 'd', þ: 'th', ħ: 'h',
    ı: 'i', ĳ: 'ij', ĸ: 'k', ŀ: 'l', ł: 'l', ŋ: 'n', ŧ: 't', ſ: 's', ŉ: 'n'
};
const LIGATURE = new RegExp(`[${Object.keys(LIGATURES).join('')}]`, 'g');
function fold(value) {
    return value
        .toLowerCase()
        .replaceAll(LIGATURE, letter => LIGATURES[letter])
        .normalize('NFD')
        .replaceAll(/\p{Diacritic}/gu, '');
}
export function isValidSlug(value) {
    return SLUG.test(value);
}
// Empty when the title holds nothing to build an identifier from. Callers warn
// rather than write an empty `name`.
export function slugify(title) {
    return (fold(title).match(RUNS) ?? []).join('-');
}
// A field that must hold a slug. The schemas that carry one — a skill's name, a
// plan's — read it from here, so the grammar and its message live in one place.
export const SlugSchema = z.string().refine(isValidSlug, 'must be a slug (lowercase letters, digits and hyphens)');
